import {useAuth} from "react-oidc-context";
import {Navigate} from "react-router-dom";
import {useAuthPermissions} from "../hooks/useAuthPermissions";
import SkeletonLoadingTS from "./SkeletonLoadingTS";

const ProtectedRoute = ({children, roles}) => {
  const auth = useAuth();
  const {verifyRole} = useAuthPermissions();
  // Mostrar loading mientras OIDC está cargando
  if (auth.isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh"
        }}
      >
        Cargando...
      </div>
    );
  }

  if (auth.isLoading) {
    return <SkeletonLoadingTS />;
  }
  // No autenticado → acceso
  if (!auth.isAuthenticated) {
    return <Navigate to="/acceso" replace />;
  }

  // Autenticado pero sin rol
  if (roles && !verifyRole(roles)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
